export default "__VITE_ASSET__BjcX_BFk__"